import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ITaskSubject } from "../../utils/types/models";

export default createEntityReducer<ITaskSubject>(Endpoint.TaskSubjects, Endpoint.TaskSubjectsList);
